import { render, staticRenderFns } from "./sendMsg.vue?vue&type=template&id=91fbc4ba&scoped=true&"
import script from "./sendMsg.vue?vue&type=script&lang=js&"
export * from "./sendMsg.vue?vue&type=script&lang=js&"
import style0 from "./sendMsg.vue?vue&type=style&index=0&id=91fbc4ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91fbc4ba",
  null
  
)

export default component.exports